import { lazyRouteComponent } from "@tanstack/react-router";
import { Activity } from "lucide-react";

import type { PageDef } from "@/app/registry";

export const pages: PageDef[] = [
  {
    path: "/app/data-health",
    title: "Data health",
    component: lazyRouteComponent(() => import("./DataHealthPage"), "DataHealthPage"),
    nav: { label: "Data health", icon: Activity, group: "System", order: 10 },
    ownerOnly: true,
  },
];
